// Collection page price filter code start

(function () {
    function clamp(value, min, max) {
        value = parseInt(value, 10);
        if (isNaN(value)) value = min;
        return Math.max(min, Math.min(max, value));
    }

    function initPriceSlider(wrapper) {
        if (wrapper.dataset.priceSliderInit === "1") return;
        wrapper.dataset.priceSliderInit = "1";

        const lower = wrapper.querySelector(".cus-lower");
        const upper = wrapper.querySelector(".cus-upper");
        const inputMin = wrapper.querySelector(".price-one");
        const inputMax = wrapper.querySelector(".price-two");

        if (!lower || !upper || !inputMin || !inputMax) return;

        const priceRange = (function (el) {
            let pr = el.closest("price-range");
            if (pr) return pr;

            let prev = el.previousElementSibling;
            while (prev) {
                if (prev.tagName && prev.tagName.toLowerCase() === "price-range") {
                    return prev;
                }
                prev = prev.previousElementSibling;
            }

            return el.parentElement
                ? el.parentElement.querySelector("price-range")
                : null;
        })(wrapper);

        let hiddenMin = null;
        let hiddenMax = null;

        if (priceRange) {
            const minId = priceRange.getAttribute("data-min-id");
            const maxId = priceRange.getAttribute("data-max-id");

            if (minId) hiddenMin = priceRange.querySelector("#" + CSS.escape(minId));
            if (maxId) hiddenMax = priceRange.querySelector("#" + CSS.escape(maxId));

            if (!hiddenMin) hiddenMin = priceRange.querySelector('input[id$="-GTE"]');
            if (!hiddenMax) hiddenMax = priceRange.querySelector('input[id$="-LTE"]');
        }

        const min = parseInt(lower.min || "0", 10);
        const max = parseInt(lower.max || upper.max || "1000", 10);

        updateMin(lower.value || min);
        updateMax(upper.value || max);

        lower.addEventListener("input", function (e) {
            updateMin(e.target.value);
        });

        upper.addEventListener("input", function (e) {
            updateMax(e.target.value);
        });

        inputMin.addEventListener("change", function (e) {
            updateMin(e.target.value);
        });

        inputMax.addEventListener("change", function (e) {
            updateMax(e.target.value);
        });

        function updateMin(value) {
            value = clamp(value, min, max - 4);

            if (value > parseInt(upper.value, 10) - 4) {
                value = parseInt(upper.value, 10) - 4;
            }

            lower.value = value;
            inputMin.value = value;

            if (hiddenMin) {
                hiddenMin.value = value;
                hiddenMin.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }

        function updateMax(value) {
            value = clamp(value, min + 4, max);

            if (value < parseInt(lower.value, 10) + 4) {
                value = parseInt(lower.value, 10) + 4;
            }

            upper.value = value;
            inputMax.value = value;

            if (hiddenMax) {
                hiddenMax.value = value;
                hiddenMax.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }
    }

    function initAllPriceSliders(scope) {
        (scope || document)
            .querySelectorAll(".custom-price-filter")
            .forEach(initPriceSlider);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            initAllPriceSliders();
        });
    } else {
        initAllPriceSliders();
    }

    window.initCustomPriceFilters = initAllPriceSliders;

    /* ================= MOBILE FIX ================= */
    /* Mobile filter drawer usually renders/opens later, so we
       re-run the init whenever the drawer is opened, and also
       watch for DOM changes (AJAX facet updates) as a safety net. */

    // 1) Re-init when user opens the mobile filter drawer
    document.addEventListener("click", function (e) {
        if (
            e.target.closest(
                ".custom-filter-drawer, .mobile-facets__open-wrapper, [data-mobile-filter-trigger]"
            )
        ) {
            setTimeout(function () {
                window.initCustomPriceFilters();
            }, 150); // small delay so drawer HTML is in the DOM
        }
    });

    // 2) Re-init on Shopify section load/select (theme editor + AJAX sections)
    document.addEventListener("shopify:section:load", function () {
        window.initCustomPriceFilters();
    });

    // 3) Watch mobile facets/drawer container for DOM changes (AJAX filter apply, etc.)
    document.addEventListener("DOMContentLoaded", function () {
        const mobileFacets = document.querySelector(
            "#MobileFacets, .mobile-facets, .custom-filter-drawer"
        );
        if (mobileFacets) {
            new MutationObserver(function () {
                window.initCustomPriceFilters();
            }).observe(mobileFacets, { childList: true, subtree: true });
        }
    });
})();

// Collection page price filter code end

// collection page description read more read less code start

document.querySelector(".collection_description_read_more")?.addEventListener("click", function () {
    document.querySelector(".collection_description_info")?.classList.add("active"),
        (this.style.display = "none"),
        (document.querySelector(".collection_description_read_less").style.display = "inline-flex");
})
document.querySelector(".collection_description_read_less")?.addEventListener("click", function () {
    document.querySelector(".collection_description_info")?.classList.remove("active"),
        (this.style.display = "none"),
        (document.querySelector(".collection_description_read_more").style.display = "inline-flex");
})



document.addEventListener("DOMContentLoaded", function () {
    document.querySelector(".custom-mobile-facets__close")?.addEventListener("click", function () {
        document.querySelector(".mobile-facets__close")?.click();
    });
})

// collection page description read more read less code start

// Update delivery time based on the selected location code start

document.querySelectorAll('.custom-location-select').forEach((wrapper) => {
  const trigger = wrapper.querySelector('.custom-location-trigger');
  const panel = wrapper.querySelector('.custom-location-panel');
  const hiddenInput = wrapper.querySelector('#locationSelect');
  const triggerText = wrapper.querySelector('.custom-location-trigger__text');
  
  // FIX: Document level par target karein taaki wrapper ke bahar ka element mil sake
  const deliveryTime = wrapper.closest('.delivery-popup-content')?.querySelector('#deliveryTime') || document.querySelector('#deliveryTime');

  trigger.addEventListener('click', () => {
    const isOpen = !panel.hidden;
    panel.hidden = isOpen;
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });

  panel.querySelectorAll('.custom-location-option').forEach((li) => {
    li.addEventListener('click', () => {
      // 1. Update hidden input value
      hiddenInput.value = li.dataset.value;

      // 2. Update trigger text
      triggerText.textContent = li.querySelector('span:last-child').textContent;

      // 3. Update delivery time text
      const delivery = li.dataset.delivery; // dataset.delivery ka use karna safe aur clean hai
      if (deliveryTime && delivery) {
        deliveryTime.textContent = delivery;
      }

      // 4. Update selected class state
      panel.querySelectorAll('.custom-location-option').forEach(o => o.classList.remove('is-selected'));
      li.classList.add('is-selected');

      // 5. Close panel
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
  });
});

// Update delivery time based on the selected location code end

// Toggle delivery-block popup on trigger click (768px - 1100px) code start
document.addEventListener('DOMContentLoaded', function () {
  const deliveryBlock = document.querySelector('.custom-delivery-block');
  const popupTrigger = deliveryBlock?.querySelector('.delivery-popup-trigger');

  if (!deliveryBlock || !popupTrigger) return;

  popupTrigger.addEventListener('click', function (e) {
    e.stopPropagation();
    const isActive = deliveryBlock.classList.toggle('delivery-popup-active');
    popupTrigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  });

  document.addEventListener('click', function (e) {
    if (!deliveryBlock.contains(e.target)) {
      deliveryBlock.classList.remove('delivery-popup-active');
      popupTrigger.setAttribute('aria-expanded', 'false');
    }
  });
});
// Toggle delivery-block popup on trigger click code end